import { TouringCardTable, TouringCardTableBody } from '@common';
import { VenueCompsTableRow } from './components';
import { venueCompsRows } from './data';

type VenueCompsTablePropsType = {
  venueComps: string | null;
};

export const VenueCompsTable: React.FC<VenueCompsTablePropsType> = ({
  venueComps,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {venueCompsRows.map((row) => (
          <VenueCompsTableRow
            key={row.label}
            venueComps={venueComps}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};

